import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=1fe164f0&scoped=true"
import script from "./goodsAdd.vue?vue&type=script&lang=js"
export * from "./goodsAdd.vue?vue&type=script&lang=js"
import style0 from "./goodsAdd.vue?vue&type=style&index=0&id=1fe164f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe164f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe164f0')) {
      api.createRecord('1fe164f0', component.options)
    } else {
      api.reload('1fe164f0', component.options)
    }
    module.hot.accept("./goodsAdd.vue?vue&type=template&id=1fe164f0&scoped=true", function () {
      api.rerender('1fe164f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/goodsAdd.vue"
export default component.exports